import React, { useEffect } from "react";
import { Container, Navbar, Nav, NavDropdown, Button } from "react-bootstrap";
import { useNavigate, NavLink } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "./LandingSection.css";

export default function LandingSection({
  backgroundImage = "/default-landing.jpg",
  showTopbar = true,
  showNavbar = true,
  customHeight,
  children,
}) {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ once: true, duration: 1000, offset: 120 });
  }, []);

  return (
    <header className="landing-section">
      {/* Background Image */}
      <div
        className="landing-bg"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          height: customHeight || "100vh",
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
        }}
      />
      <div className="landing-overlay" />

      {/* TOPBAR */}
      {showTopbar && (
        <div className="topbar-new">
          <Container>
            <div className="topbar-center">
              <span>
                <i className="bi bi-clock"></i> Mon–Fri: 7:00 – 20:00
              </span>
              <a href="tel:+4917655439634">
                <i className="bi bi-telephone"></i> +49 176 55439634
              </a>
              <a href="mailto:Kontakt@transcirox.com">
                <i className="bi bi-envelope"></i> Kontakt@transcirox.com
              </a>
            </div>
          </Container>
        </div>
      )}

  

      {/* Custom Hero Content */}
      <div className="py-5">
        <Container fluid>{children}</Container>
      </div>
    </header>
  );
}
